<template>
    <div>
      <breadcrumb :routerList="[{to:'/agent/ability',title:'经销商能力胜任测评'}]"/>
<!--      <Breadtabsheader/>-->
        <div class="h-content" >
            <!-- 搜素条件 -->
            <div class="h-piece" >
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                  <div class="h-thirdColumn w-newColumn">
                      <el-form-item label="经销商名称">
                            <el-input v-model="q.agentName" placeholder="请输入经销商名称" :clearable="true"></el-input>
					            </el-form-item>
                      <el-form-item label="经销商编码">
                        <el-input v-model="q.agentCode" placeholder="请输入经销商编码" :clearable="true"></el-input>
                      </el-form-item>
<!--                      <el-form-item label="客户">-->
<!--                        <el-input v-model="q.customerName" placeholder="请输入客户名称/编码" :clearable="true"></el-input>-->
<!--                      </el-form-item>-->
                      <el-form-item label="区域" prop="area">
                        <el-select v-model="q.areaName" clearable placeholder="请选择" style="width:100%">
                          <el-option v-for="item in quyuList"
                                     :key="item.code"
                                     :label="item.name"
                                     :value="item.name">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    <el-form-item label="年度">
                      <el-select filterable v-model="q.year" clearable placeholder="请选择">
                        <el-option
                            v-for="(item,index) in yearList"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="h-thirdColumn w-newColumn">
                    <el-form-item label="季度" prop="quarterly">
                      <el-select v-model="q.quarter" :clearable="true"
                                    placeholder="请选择">
                        <el-option label="1" value="1"></el-option>
                        <el-option label="2" value="2"></el-option>
                        <el-option label="3" value="3"></el-option>
                        <el-option label="4" value="4"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="状态" prop="quarterly">
                      <el-select v-model="q.status" :clearable="true"
                                 placeholder="请选择">
                        <el-option label="正常" value="0"></el-option>
                        <el-option label="审批中" value="1"></el-option>
                        <el-option label="驳回" value="2"></el-option>
                        <el-option label="待评分" value="3"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-form>
                <!-- 展开搜素 -->
                <div class="l-screenBox">
                    <!-- <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                    </div> -->
                    <div class="l-retrieval">
                    <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
<!--                      <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createdAbility">-->
<!--                        新建目标-->
<!--                    </el-button>-->
                    </div>
                </div>
            </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!--  -->
              <el-table
                  ref="ddtable"
                  :data="tableData"
                  @selection-change="handleSelectionChange"
                  stripe
                  border
                  style="width: 100%">

                <el-table-column
                    type="selection"
                    width="40">
                </el-table-column>
                <el-table-column
                    type="index"
                    width="40"
                    label="序号"
                     >
                </el-table-column>
                <el-table-column
                    prop="agentCode"
                    label="经销商编码"
                    width="110"
                    >
                </el-table-column>
                <el-table-column
                    prop="agentName"
                    label="经销商名称"
                    width="125">
                </el-table-column>
                <el-table-column
                    prop="year"
                    label="年度"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="quarter"
                    label="季度"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="areaName"
                    label="区域"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="legal"
                    label="法人代表"
                    width="125">
                </el-table-column>
                <el-table-column
                    prop="evaluationDate"
                    label="测评日期"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="againstAreaActualCount"
                    label="对阵地市实际（个数）"
                    width="130">
                </el-table-column>
                <el-table-column
                    prop="againstUserActualCount"
                    label="对阵用户实际（个数）"
                    width="130">
                </el-table-column>
                <el-table-column
                    prop="againstAreaTargetCount"
                    label="对阵地市目标（个数）"
                    width="130">
                </el-table-column>
                <el-table-column
                    prop="againstUserTargetlCount"
                    label="对阵用户目标（个数）"
                    width="130">
                </el-table-column>
                <el-table-column
                    prop="yearActual"
                    label="年实际"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="yearTargetl"
                    label="年目标"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="quarterActual"
                    label="季度实际"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="quarterTargetl"
                    label="季度目标"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="yearLx"
                    label="年履约率"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="quarterLx"
                    label="季度履约率"
                    width="110">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    width="110">
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.status == 0">正常</span>
                    <span v-if="scope.row.status == 1">审批中</span>
                    <span v-if="scope.row.status == 2">驳回</span>
                    <span v-if="scope.row.status == 3">待评分</span>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="cdate"
                    label="创建日期"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="cuname"
                    label="创建人"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="luname"
                    label="更新人"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="ldate"
                    label="最后更新时间"
                    width="150">
                </el-table-column>

                <el-table-column
                    fixed="right"
                    label="操作"
                    width="240" >
                  <template slot-scope="scope">
                    <div class="w-caozuo" style="text-align: left;">
                      <el-button
                          type="text"
                          size="small"
                          class="h-tableLink h-btn"
                          @click="toSee(scope.row)">
                        查看
                      </el-button>
                      <el-button
                          type="text"
                          size="small"
                          class="h-tableLink h-btn"
                          @click="printDetail(scope.row)">
                        导出明细
                      </el-button>
                    <el-button
                        type="text"
                        size="small"
                        class="h-tableLink h-btn"
                        v-if="scope.row.status == 2 && isUpdate"
                        @click="resubmit(scope.row)">
                      重新提交
                    </el-button>
                    <el-button
                        type="text"
                        size="small"
                        @click="createdAbility(scope.row)"
                        v-if="scope.row.status == 3 && isUpdate"
                        class="h-tableLink h-btn"
                      >
                      评分
                    </el-button>
                    <el-button
                        type="text"
                        size="small"
                        @click="gcSummary(scope.row)"
                        v-if="scope.row.gcStatus == 1 && scope.row.status == 0 && isUpdate"
                        class="h-tableLink h-btn"
                    >
                      关差总结
                    </el-button>
                    <el-button v-if="scope.row.instid != null && scope.row.instid != ''"
                               size="small" class="h-tableLink h-btn"
                               type="text"
                               @click="genzongLiuch(scope.row.instid)">
                      跟踪
                    </el-button>
                    </div>
                  </template>


                </el-table-column>
              </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <div class="h-tableBL">
                          <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
<!--                             <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除</el-button>-->
<!--                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>-->
<!--                            <uploaddownexcel-->
<!--                                    :visible.sync="uploaddownexcelflag"-->
<!--                                    v-if="uploaddownexcelflag"-->
<!--                                    clsname="bscTargetAgainstUserExcel"-->
<!--                                    :startrow="2" @callback="uploadExcelFilecallback"/>                        -->
                        </div>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import agentAbilityService from "../../../../api/loud/agentability/agentAbilityService.js";
import updownfile from "../../../../utils/updownfile";
import ss from "../../../../api/SystemService";
export default {
    data() {
        return {
          //查询属性
          q: {
            agentCode:null,
            agentName:null,
            year:null,
            quarter:null,
            status:null,
            weekTime:'',
            delflag:1,
            pageSize:10,
            pageNo:1,
            total:0,
          },
          bscUserInfoAgentAbility:{
             agentCode:null,//经销商编码
             agentName:null,//经销商名称
             evaluationDate:null,//测评日期
             areaName:null,//地区
             areaCode:null,//地区编码
             legal:null,//法人代表
             againstAreaActualCount:null,//对阵地市实际（个数）
             againstUserActualCount:null,//对阵用户实际（个数）
             againstAreaTargetCount:null,//对阵地市目标（个数）
             againstUserTargetlCount:null,//对阵用户目标（个数）
             yearActual:null,//年实际
             yearTargetl:null,//年目标
             quarterActual:null,//季度实际
             quarterTargetl:null,//季度目标
             yearLx:null,//年履约率
             quarterLx:null,//季度履约率
             tdjsA:null,//有新增海尔业务人员
             tdjsB:null,//团队能力，产品知识培训获得海尔认可的专业考核
             xmxxglA:null,//漏斗信息对指标的支撑度；无虚假，无漏单
             xmxxglB:null,//漏斗信息用户对阵数量的覆盖率
             sctgtrA:null,//市场专项推广会（数量+质量）
             sctgtrB:null,//分销商会议（数量+质量）
             yhgxgsA:null,//薄弱的重点用户关差效果
             yhgxgsB:null,//空白用户关差效果
             fxtxjsA:null,//分销商建设数量及覆盖能力
             fxtxjsB:null,//单分销商的规模及分销商的满意度回访
             conclusion:null,//评价结论＜60分 区域调整或终止协议60-80分 整改＞80分 继续合作
             projectScore:null,//项目测评得分（40%）
             performanceScore:null,//业绩得分（60%）
             evaluateSummarize:null,//评价总结
             daquConfirm:null,//大区确认
             quyuConfirm:null,//区域确认
             passDifference:null,//关差总结
              status:null,
          },
          size:'',
          tableData: [],
          //表格
          multipleSelection: [],
          // 展开折叠筛选
          isScreen:false,
          uploaddownexcelflag:false,
          newDialog:false,
          editDialog:false,
          isUpdate:false,
          showhistory: null,
          instid:null,
          quyuList:[],
          weekList:[],
          yearList:[new Date().getFullYear()-1,new Date().getFullYear(),new Date() .getFullYear()+1],
      }
        
    },
   
  methods: {
         
        //表格
      handleSelectionChange(val) {
         this.multipleSelection = val;
      },
      query() {
        agentAbilityService.selecPage(this.q).then(rd=>{
          this.q.total = rd.total;
          this.tableData = rd.records;
        })
      },
      genzongLiuch(v) {
        console.log(v);
        this.instid = v;
        this.showhistory = true;
      },
      handleFilter() {
        this.query();
      },
      deleteSelete(){
          // var data = this.multipleSelection.map(item => item.id).join()
          var idlist = [];
          this.multipleSelection.forEach(element => {
            idlist.push(element.id);
          });
          console.log(idlist)
          this.deleteSingle(idlist)
      },

      //评分
      createdAbility(q) {
        this.$router.push({path: "/agent/addAgentAbility",query: {id: q.id}});
      },
      //关差总结
      gcSummary(q) {
        this.$router.push({path: "/agent/seeAgentAbility",query: {id: q.id,gcbutton:"true"}});
      },
      //查看按钮功能
      toSee(q) {
        this.$router.push({path: '/agent/seeAgentAbility',query: {id: q.id}});
      },
      //重新提交
      resubmit(q){
        this.$router.push({path: '/agent/resubmitAgentAbility',query: {id: q.id}});
      },
      //导出明细
      printDetail(q) {
        updownfile.down('/api/swyl/v1/demo/bscUserInfoAgentAbility/getExcel',q,"post");
      },
      //重置
      rest(){
        this.q.agentCode=null;
        this.q.agentName=null;
        this.q.year=null;
        this.q.weekTime=null;
        this.q.quarter=null;
        this.q.status=null;
        this.q.year=null;
      },
      getQuyuList(){
        ss.Dictservice.listbycategory("YLRegion").then(rd=>{
          this.quyuList = rd;
        })
      },



  },
  watch:{
      'add.customerName': {
          deep: true,
          handler: function (newVal,oldVal){
          this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
          var len = this.groupList.length;//groupList
          var arr = [];
          for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
              if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
              arr.push({
                  value:this.groupList[i].name,
                  id:this.groupList[i].id
              })
              }
          }
          this.groupArr = arr
          }
      },
  },
  created(){
      this.handleFilter();
      this.getQuyuList();
      this.isUpdate = this.$store.getters.hasRole('swyl_admin,swyl_quyujl');
  },
  components: {

  },
}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:80px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
</style>